import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { trackEvent as track } from '../utils/analytics';
import { TrustHero } from '../components/trust/TrustHero';
import { TrustChallenge } from '../components/trust/TrustChallenge';
import { TrustSolution } from '../components/trust/TrustSolution';
import { TrustFinalCTA } from '../components/trust/TrustFinalCTA';
export function Trust() {
  useEffect(() => {
    track('Page Viewed', {
      page: 'Trust'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8758" data-mp="39rh89by7nqc8">
      <Header data-id="element-8759" data-mp="34zz9mujnu1uf" />
      <main className="pt-[120px]" data-id="element-8760" data-mp="34zh1p0nmxz6o">
        <TrustHero data-id="element-8761" data-mp="34yfs70m9pkr2" />
        <TrustChallenge data-id="element-8762" data-mp="34xw9vispguci" />
        <TrustSolution data-id="element-8763" data-mp="301pcwfiaet6p" />
        <TrustFinalCTA data-id="element-8764" data-mp="3004kavfj9kbh" />
      </main>
      <Footer data-id="element-8765" data-mp="2zz34kdnko9nf" />
    </div>;
}